import { useCallback, useState } from 'react';

/**
 * Helper hook to force the component to re-render.
 */
export function useForceUpdate() {
  const [, updateState] = useState<Record<string, never>>();

  return useCallback(() => updateState({}), []);
}
